import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const ProfileLabeledInput = forwardRef(function ProfileLabeledInput(
  {
    id,
    label,
    type = 'text',
    value,
    onChange,
    disabled = false,
    className,
    inputClassName,
    errors,
    ...inputProps
  },
  ref
) {
  const rootClass = ['profile-div', className].filter(Boolean).join(' ');
  const inputCls = ['profile-input', inputClassName].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <div className="profile-div profile-label-wrapper">
        <span className="profile-span">{label}</span>
      </div>
      <div className="profile-div input-container">
        <input
          ref={ref}
          id={id || label}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={inputCls}
          {...inputProps}
        />
        {errors && <span className="color-error profile-span">{errors}</span>}
      </div>
    </div>
  );
});

ProfileLabeledInput.displayName = 'ProfileLabeledInput';

ProfileLabeledInput.propTypes = {
  // id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string
};

export default ProfileLabeledInput;
